/**
 * When Upcart is present, intercept subscription ATC links so we can
 * AJAX-add and let EasyGift + Upcart open the drawer — never navigate to /cart.
 * Without Upcart, the link's /cart/add?...selling_plan=... href is followed.
 */
(function () {
  'use strict';

  var SELECTOR = 'a[data-subscription-atc]';
  var isSubmitting = false;
  var BUSY_RESET_MS = 6000;

  function openUpcart() {
    if (typeof window.upcartRegisterAddToCart === 'function') {
      window.upcartRegisterAddToCart();
    }
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
    }
  }

  function clearBusy(link) {
    isSubmitting = false;
    if (link) {
      link.removeAttribute('aria-busy');
    }
  }

  function postCartAdd(variantId, sellingPlanId) {
    // Use fetch: some third-party apps patch XMLHttpRequest and hang /cart/add.js.
    // Do not AbortController — aborting can cancel EasyGift's in-flight gift flow.
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            selling_plan: Number(sellingPlanId),
          },
        ],
      }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('status ' + response.status);
      }
      return response.json();
    });
  }

  function onClick(event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = target && target.closest(SELECTOR);
    if (!link || isSubmitting) return;

    // Only intercept when Upcart APIs exist; otherwise let the link navigate.
    if (typeof window.upcartOpenCart !== 'function' && typeof window.upcartRegisterAddToCart !== 'function') {
      return;
    }

    var variantId = link.getAttribute('data-variant-id');
    var sellingPlanId = link.getAttribute('data-selling-plan-id');
    if (!variantId || !sellingPlanId) return;

    event.preventDefault();
    isSubmitting = true;
    link.setAttribute('aria-busy', 'true');

    // Safety timer: clear busy state only — never navigate, never abort fetch.
    var busyTimer = window.setTimeout(function () {
      clearBusy(link);
    }, BUSY_RESET_MS);

    postCartAdd(variantId, sellingPlanId)
      .then(function (data) {
        // Shopify error payloads include a status field; still stay on-page.
        if (!(data && data.status)) {
          openUpcart();
        }
      })
      .catch(function () {
        // EasyGift may hold/alter the request while the gift modal is open.
        // Stay on the page; Upcart openOnAddToCart will open the drawer after the gift is chosen.
      })
      .finally(function () {
        window.clearTimeout(busyTimer);
        clearBusy(link);
      });
  }

  document.addEventListener('click', onClick);
})();
